import { AddTabToWorkspaceOptions, openTabInWorkspaceEpic } from 'epic/workspace/common/tabs/tabsEpics';
import { EpicWithThunk, Thunk } from 'state/state.common';
import { SecondaryMarketBatchReloadOrdersAction } from 'state/workspaces/secondary-market/batch/actions';
import { secondaryOrderBlotterCPOrderTabCreatedThunk } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.thunks';
import { WorkspacePersistedTabsApplied } from 'state/workspaces/workspace.actions';

function openThunk({ payload: { orderType, rows } }: SecondaryMarketBatchReloadOrdersAction): Thunk<void> {
  return dispatch => {
    if (orderType === 'cp-order') {
      for (const row of rows) {
        dispatch(
          secondaryOrderBlotterCPOrderTabCreatedThunk({
            isin: row.isin,
            fileCode: row.fileCode,
            productIdSource: row.bcsKey.source,
            productIdType: row.bcsKey.subType,
            productIdValue: row.bcsKey.code,
          }),
        );
      }
    }
  };
}
export function secondaryWorkspaceReloadOrdersEpic(): EpicWithThunk {
  const opt: AddTabToWorkspaceOptions<SecondaryMarketBatchReloadOrdersAction, WorkspacePersistedTabsApplied> = {
    workspaceReadyTriggers: ['WORKSPACE_PERSISTED_TABS_APPLIED'],
    targetWorkspace: 'secondaryMarketQuotes',
    triggers: ['SECONDARY_MARKET_BATCH_RELOAD_ORDERS'],
    navigateRoute: { path: '/secondary-market-quotes-workspace' },
    onReady: action => {
      return openThunk(action);
    },
  };
  return openTabInWorkspaceEpic(opt);
}
